<template>
  <div>
    <vue-headful
      title="Contact"
      description="Mathew Moose - Software Engineer. This is a portfolio site used to showcase some of my work."
    />
    <section class="section full-height">
        <div class="columns is-laptop full-height">
          <div class="column is-two-fifths-desktop">
            <h1 class="title is-1">Contact</h1>
            <hr>
            <p class="has-text-centered">Please feel free to contact me at <a href="mailto:mathewmoose95@gmail.com">MathewMoose95@gmail.com</a> or use the form below.</p>
            <p class="has-text-centered" style="margin-bottom:1.5rem">I look forward to hearing from you!</p>
            <form @submit.prevent="handleFormSubmit" id="gform" method="POST" action="https://script.google.com/macros/s/AKfycbyPw_x8CzTobCwVac9UQ-ibwYDtertPXAfZxBpFnDbA8uOcc2o/exec">
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <div class="control has-icons-left">
                      <input name="name" :class="['input', {'is-success' : validName}, {'is-danger': changed.name && !validName} ]" type="text" placeholder="Name" v-model="name" @keypress="changed.name=true" required>
                      <span class="icon is-left">
                        <font-awesome-icon :icon="['fas', 'id-card-alt']"/>
                      </span>
                    </div>
                    <p v-if="changed.name && !validName" class="help is-danger">Please enter your name.</p>
                  </div>
                  <div class="field">
                    <div class="control has-icons-left">
                      <input name="email" :class="['input', {'is-success' : validEmail}, {'is-danger': changed.email && !validEmail} ]" type="email" placeholder="Email" v-model="email" @keypress="changed.email=true" required>
                      <span class="icon is-left">
                        <font-awesome-icon :icon="['fas', 'envelope']"/>
                      </span>
                    </div>
                    <p v-if="changed.email && !validEmail" class="help is-danger">Please enter a valid email.</p>
                  </div>
                </div>
              </div>
              <input id="honeypot" type="text" name="honeypot" value="" style="display: none"/>
              <div class="field">
                <div class="control has-icons-left">
                  <input name="subject" class="input" type="text" placeholder="Subject">
                  <span class="icon is-left">
                    <font-awesome-icon :icon="['fas', 'pencil']"/>
                  </span>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <textarea name="message" :class="['textarea', {'is-success' : validMessage}, {'is-danger': changed.message && !validMessage} ]" placeholder="Message" v-model="message" @keypress="changed.message=true" required></textarea>
                </div>
                <p v-if="changed.message && !validMessage" class="help is-danger">Please enter a message.</p>
              </div>
              <div class="field">
                <div class="control">
                  <button class="button is-primary" :disabled="!readyToSubmit">Submit</button>
                </div>
              </div>
            </form>
            <div id="submitted">
            Your email has been sent successfully. Thank you!
            </div>
          </div>
          <div class="column">
            <google-map></google-map>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
import GoogleMap from '@/components/GoogleMap.vue'
export default {
  components: {
    'google-map': GoogleMap
  },
  methods: {
    validateHuman: function (honeypot) {
      if (honeypot) { return true }
      return false
    },
    getFormData: function () {
      var form = document.getElementById('gform')
      var elements = form.elements
      var fields = Object.keys(elements).filter(function (k) {
        return (elements[k].name !== 'honeypot')
      }).map(function (k) {
        if (elements[k].name !== undefined) {
          return elements[k].name
        } else if (elements[k].length > 0) {
          return elements[k].item(0).name
        }
      }).filter(function (item, pos, self) {
        return self.indexOf(item) === pos && item
      })
      var data = {}
      fields.forEach(function (k) {
        data[k] = elements[k].value
        var str = ''
        if (elements[k].type === 'checkbox') {
          str = str + elements[k].checked + ', '
          data[k] = str.slice(0, -2)
        } else if (elements[k].length) {
          for (var i = 0; i < elements[k].length; i++) {
            if (elements[k].item(i).checked) {
              str = str + elements[k].item(i).value + ', '
              data[k] = str.slice(0, -2)
            }
          }
        }
      })
      data.formDataNameOrder = JSON.stringify(fields)
      data.formGoogleSheetName = form.dataset.sheet || 'responses'
      data.formGoogleSendEmail = form.dataset.email || ''
      return data
    },
    handleFormSubmit: function (event) {
      event.preventDefault()
      var data = this.getFormData()
      if (this.validateHuman(data.honeypot)) { return false }
      var url = event.target.action
      var xhr = new XMLHttpRequest()
      xhr.open('POST', url)
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      xhr.onreadystatechange = function () {
        document.getElementById('gform').style.display = 'none'
        document.getElementById('submitted').style.display = 'block'
      }
      var encoded = Object.keys(data).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
      }).join('&')
      xhr.send(encoded)
    }
  },
  data: function () {
    return {
      changed: {
        name: false,
        email: false,
        message: false
      },
      name: null,
      email: null,
      message: null
    }
  },
  computed: {
    validName: function () {
      if (this.name) {
        return !(this.name.length === 0 || !this.name.trim())
      }
      return false
    },
    validEmail: function () {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.email)
    },
    validMessage: function () {
      if (this.message) {
        return !(this.message.length === 0 || !this.message.trim())
      }
      return false
    },
    readyToSubmit: function () {
      return this.validName && this.validEmail && this.validMessage
    }
  }
}
</script>

<style scoped>
  .full-height{
    height: 100%;
  }
  .fa-icon{
    color: cyan;
    margin-bottom: 5px;
  }
  a {
    color: cyan;
    text-decoration: none;
  }
  #submitted{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactPage.vue